export enum models {
  string = 'string',
  number = 'number'
}
